module.exports = __webpack_public_path__ + "static/media/insufficient-permission-image.04c5beaa.png";